
import { Mixins, Component, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import CompanyInfoMixin from '@/_mixins/companyInfo.mixin'

import { openDialog } from '@/_components/dialog/dialog'

import DialogUserLog from '@/views/User/dialogs/userLog/userLog.vue'
import DialogProjectUserLog from '@/views/Authorization/dialogs/userLog/userLog.vue'

import UserAutocomplete from '@/components/Autocomplete/user.vue'
import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'
import ContractorInfo from '@/views/Project/Observation/components/contractorInfo.vue'
import Permissions from '@/components/permissions.vue'

import SetCard from '@/views/User/views/Admin/dialogs/setCard.vue'
import ToggleIsEnabled from '@/views/User/views/Admin/dialogs/toggleIsEnabled.vue'

import { searchCompanyAdmin, searchProjectUsers } from '@/utils/authorization'

// Remove in the future
import Authentication from '@/views/Authentication/models/authentication'

@Component({
    mixins: [CompanyInfoMixin],
    components: { UserAutocomplete, UserAvatar, ContractorInfo, Permissions },
})
export default class UsersManager extends Mixins<MixinInterface>(CompanyInfoMixin) {
    user: any = null

    @Watch('user', { deep: true })
    cleanUp() {
        this.showProjects = false
        this.projectUsers = []
        this.projectUserOffset = 0
        this.projectUserCompleted = false
        this.projectSearchTerm = ''
        this.showCompanies = false
        this.companyAdmins = []
        this.companyAdminsOffset = 0
        this.companyAdminsCompleted = false
    }

    // Impersonate
    loadingImpersonating = false

    async impersonate(userId: string | null) {
        if (this.loadingImpersonating) return

        this.loadingImpersonating = true
        await Authentication.impersonate(userId)
        this.loadingImpersonating = false
    }

    // Cars
    async setCard() {
        if (!this.user) return
        const user = await openDialog(SetCard, {
            user: this.user,
        })

        if (user) {
            this.user = user
        }
    }

    //IsEnabled
    async toggleIsEnabled() {
        if (!this.user) return

        const user = await openDialog(ToggleIsEnabled, {
            user: this.user,
        })

        if (user) {
            this.user = user
        }
    }

    // Project User Information
    showProjects = false
    projectSearchTerm = ''
    projectUserOffset = 0
    projectUserLimit = 20
    projectUserCompleted = false
    projectUsers: Array<any> = []

    projectUserFields = ['jobTitle', 'jobDescription', 'email', 'invitationMessage']

    get filteredProjectUsers() {
        return this.projectSearchTerm
            ? this.projectUsers.filter((user) =>
                  user.project?.data?.name
                      .toLowerCase()
                      .includes(this.projectSearchTerm.toLowerCase())
              )
            : this.projectUsers
    }

    async getProjectUsers($state: any) {
        if (!this.projectUserCompleted) {
            const filters = {
                ...(this.user && { 'filter[user]': this.user.id }),
                'page[offset]': this.projectUserOffset,
                'page[limit]': this.projectUserLimit,
            }

            const include =
                'displayContractor,displayContractor.company,project,company,roles.permissions,roles.includedPermissions'

            const res = await searchProjectUsers(filters, include)
            this.projectUserOffset += res.length

            if (Object.keys(res).length == this.projectUserLimit) {
                $state.loaded()
            } else {
                this.projectUserCompleted = true
                $state.complete()
            }
            this.projectUsers = [...this.projectUsers, ...res]
        } else {
            $state.complete()
        }
    }

    // Company admin User Information
    showCompanies = false
    companyAdminsOffset = 0
    companyAdminsLimit = 20
    companyAdminsCompleted = false
    companyAdmins: Array<any> = []

    async getCompanyAdmins($state: any) {
        if (!this.companyAdminsCompleted) {
            const include = 'company'
            const filters = {
                ...(this.user && { 'filter[user]': this.user.id }),
                'page[offset]': this.companyAdminsOffset,
                'page[limit]': this.companyAdminsLimit,
            }

            let res = await searchCompanyAdmin(filters, include)
            this.companyAdminsOffset += res.length

            if (Object.keys(res).length == this.companyAdminsLimit) {
                $state.loaded()
            } else {
                this.companyAdminsCompleted = true
                $state.complete()
            }
            this.companyAdmins = [...this.companyAdmins, ...res]
        } else {
            $state.complete()
        }
    }

    // Logs
    async showLog(user) {
        await openDialog(DialogUserLog, { user: user })
    }

    async showProjectUserLog(projectUser, project) {
        await openDialog(DialogProjectUserLog, { user: projectUser, project: project })
    }
}
